import styled from 'styled-components';

import { NotificationContainer } from '../NotificationContainer';

const StyledNotificationContainer = styled(NotificationContainer)`
	background-color: rgba(0, 0, 0, 0.5);
`;

const StyledProgress = styled.div<{ $progress: number }>`
	position: absolute;
	top: 3px;
	left: 3px;
	z-index: -1;
	width: calc(${(props) => props.$progress}% - 6px);
	height: calc(100% - 6px);
	background-color: #2d70da;
	border-radius: 7px;
`;

export { StyledNotificationContainer, StyledProgress };
